import { useEffect, useState } from "react";
import TopNavbarBack from "../../components/TopNavbarBack";
import LoadingPage from "../../components/LoadingPage";
import GoToTop from "../../components/GoToTop";
import Navbar from "../../components/Navbar";
import AchievementGrid from "../../components/achievements/AchievementGrid";
import { useFetch } from "../../custom/api";
import { toFarsiNumber } from "../../custom/helpers";
import "../../styles/Containers.css";
import "../../styles/Achievements.css";

const TABS = [
  { key: "all", label: "همه" },
  { key: "earned", label: "به دست آمده" },
  { key: "locked", label: "قفل شده" },
];

// Full achievement catalog page (/achievements) - header stats + filter tabs
// + the grid grouped by category. GET achievements is the single source of
// truth for both locked/earned state and progress, per the API contract.
export default function Achievements() {
  const { myFetch } = useFetch();
  const [data, setData] = useState(undefined); // undefined = loading
  const [tab, setTab] = useState("all");

  useEffect(() => {
    const run = async () => {
      const resp = await myFetch("achievements", { method: "GET" });
      const r = await resp.json();
      setData(r);
    };
    run();
  }, []);

  if (data === undefined) return <LoadingPage />;

  const achievements = data.achievements || [];
  const filtered = achievements.filter((a) => {
    if (tab === "earned") return a.earned;
    if (tab === "locked") return !a.earned;
    return true;
  });

  return (
    <div className="backLightColor">
      <TopNavbarBack
        title="دستاوردها"
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["null"]}
      />

      <div className="main-container">
        <div className="b-white padding5 radius1-5 shadow-smooth centerAlign">
          <p className="heading-2 purple-1">
            {toFarsiNumber(data.total_earned || 0)} / {toFarsiNumber(data.total_available || 0)}
          </p>
          <p className="caption-1 grey-2 yekan">دستاورد به دست آمده</p>
          <p className="subject-1 yekan marginTop5">{toFarsiNumber(data.total_points || 0)} امتیاز کل</p>
        </div>

        <div className="achievementTabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`achievementTabBtn ${tab === t.key ? "achievementTabBtn-active" : ""} yekan`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <AchievementGrid achievements={filtered} />
      </div>

      <Navbar />
      <GoToTop />
    </div>
  );
}
